import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import BaseLayout from './BaseLayout';

import AdminHome from './AdminHome';
import ManageTeachers from './ManageTeachers';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import ManageStudents from './ManageStudents';
import AdminVisits from './AdminVisits';
import TeachersAvailability from './TeachersAvailability';
import AllStudentsInfo from './AllStudentsInfo';
import StudentProgressReport from './StudentProgressReport';
import StudentServiceAuditReport from './StudentServiceAuditReport';
import TeachersWorkTimelineReport from './TeachersWorkTimelineReport';
import AdminDocuments from './AdminDocuments';
import SettingsTimezone from './SettingsTimezone';
import StudentAchievement from './StudentAchievement';
import TeacherTimeLog from './TeacherTimeLog';
import MyStudentsAvailability from './MyStudentsAvailability';
import SmartScheduler from './SmartScheduler';
import TeacherDayPlanner from './TeacherDayPlanner';
import OrgPlansAndRoi from './OrgPlansAndRoi';
import Messages from './Messages';
import AboutHelp from './AboutHelp';
import Faq from './Faq';
import OrgActiveSessions from './OrgActiveSessions';
import TrainingVisitsPlanner from './TrainingVisitsPlanner';
import MentorTrainingDashboard from './MentorTrainingDashboard';
import AdminVisitsCalendar from './AdminVisitsCalendar';

// ✅ Billing/Insurance moduli
import AdminInsurance from './AdminInsurance';
import AdminAuthorizations from './AdminAuthorizations';
import AdminEVVExceptions from './AdminEVVExceptions';
import AdminBillingExport from './AdminBillingExport';

import AdminKpis from './AdminKpis';

// ✅ NOVO: Instruments (admin)
//import AdminInstruments from './AdminInstruments';

import AdminInstrumentsAvailability from './AdminInstrumentsAvailability';
import AdminIntakesBuilder from './AdminIntakesBuilder';
import InstrumentWorkspace from './InstrumentWorkspace';

import MyTripLogs from './MyTripLogs';
import AdminAutoPilotMonitor from './AdminAutoPilotMonitor';


const DashboardAdmin = () => {
  const location = useLocation();

  return (
    <BaseLayout role="admin">
      <Routes location={location}>
        <Route path="/" element={<AdminHome />} />

        <Route path="manage-teachers" element={<ManageTeachers />} />
        <Route path="manage-students" element={<ManageStudents />} />

        <Route path="visits" element={<AdminVisits />} />
        <Route path="calendar" element={<AdminVisitsCalendar />} />

        <Route path="scheduler" element={<SmartScheduler />} />
        <Route path="planer" element={<TeacherDayPlanner />} />

        <Route path="training" element={<TrainingVisitsPlanner />} />
        <Route path="mentor-training" element={<MentorTrainingDashboard />} />

        <Route path="students" element={<AllStudentsInfo />} />
        <Route path="availability" element={<TeachersAvailability />} />

        <Route path="student-progress" element={<StudentProgressReport />} />
        <Route path="student-service-audit" element={<StudentServiceAuditReport />} />
        <Route path="work-report" element={<TeachersWorkTimelineReport />} />

        <Route path="docs" element={<AdminDocuments />} />
        <Route path="settings" element={<SettingsTimezone />} />

        <Route path="achievement" element={<StudentAchievement mode="admin" />} />
        <Route path="students-availability" element={<MyStudentsAvailability mode="admin" />} />
        <Route path="teacher-timelogs" element={<TeacherTimeLog />} />
	    <Route path="teacher-triplogs" element={<MyTripLogs />} />
        <Route path="autopilot-monitor" element={<AdminAutoPilotMonitor />} />
        <Route path="messages" element={<Messages mode="admin" />} />
        <Route path="pricing" element={<OrgPlansAndRoi />} />
        <Route path="sessions" element={<OrgActiveSessions />} />

        {/* ✅ Billing & Compliance */}
        <Route path="insurance" element={<AdminInsurance />} />
        <Route path="authorizations" element={<AdminAuthorizations />} />
        <Route path="evv-exceptions" element={<AdminEVVExceptions />} />
        <Route path="billing-export" element={<AdminBillingExport />} />

        <Route path="kpis" element={<AdminKpis />} />

        {/* ✅ NOVO: Instruments */}
        <Route path="instruments" element={<AdminInstrumentsAvailability />} />
		<Route path="builder" element={<AdminIntakesBuilder />} />
		<Route path="instrument-submissions/:id" element={<InstrumentWorkspace />} />

        <Route path="about" element={<AboutHelp mode="admin" />} />
        <Route path="faq" element={<Faq mode="admin" />} />

        <Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </BaseLayout>
  );
};

export default DashboardAdmin;



